<template>
  <Modal title="外教离职" v-model="visible" width="520px" class-name="resign-modal">
    <div class="resign-content">
      <div class="resign-tip">
        <Icon type="ios-information-circle" size="20" color="#E6A23C" />
        <span>{{ title }}</span>
      </div>

      <Form ref="leaveForm" :label-width="120" :model="leaveParam" :rules="leaveRule">
        <FormItem label="离职类型" prop="resignType" required>
          <RadioGroup v-model="leaveParam.resignType">
            <Radio :label="1">离职</Radio>
            <Radio :label="2">淘汰</Radio>
            <Radio :label="3">失联</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="最后工作日期" prop="lastWorkDay">
          <DatePicker
            type="date"
            format="yyyy-MM-dd"
            placeholder="请选择最后工作日期"
            v-model="startTime"
            @on-change="startTimeChange"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem label="离职理由" prop="resignReason">
          <Input type="textarea" :rows="3" :maxlength="200"
            v-model="leaveParam.resignReason"
            placeholder="请输入离职理由（选填）"
            show-word-limit></Input>
        </FormItem>
        <FormItem label="议后是否再录用" prop="rehireFlag">
          <RadioGroup v-model="leaveParam.rehireFlag">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </div>

    <div slot="footer">
      <Button size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAdd" @click="add">确认离职</Button>
    </div>
  </Modal>
</template>
<script>
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'


export default {
  name: 'TchLeaveModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tchId: {
      type: Number,
      default: false
    },
    title: {
      type: String,
      default: '确认老师离职吗？'
    },
    successCallback: {
      type: Function
    }
  },
  data () {
      // let self = this
    let $constant = this.$constant
    let $moment = this.$moment
    return {
      rankScoreSeq: 0,
      visible: this.value,
      oldTch: null,
      bookLessonOpenedColumn: [
        {
          title: '学生ID、姓名',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('div', [
              h('span', row.uid),
              h('span', ' - '),
              h('span', row.userNickname || '')
            ])
          }
        },
        {
          title: '老师ID、姓名',
          width: 180,
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.tchId + ' - ' + ((row.tchFirstName || '') + ' ' + (row.tchLastName || '')).trim(),
              score: row.monthRankScore
            })
          }
        },
        {
          title: '外教运营',
          width: 80,
          key: 'tchStudyAdviserNickname'
        },
        {
          title: '学导',
          width: 80,
          key: 'studyAdviserNickname'
        },
        {
          title: '课顾',
          width: 80,
          key: 'adviserNickname'
        },
        {
          title: '课程类型',
          align: 'center',
          width: 72,
          render: (h, params) => {
            let lsnType = params.row.lsnType
            let typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType)
            return h('span', typeEnum && typeEnum.text)
          }
        },
        {
          title: '课程类别',
          align: 'center',
          width: 72,
          render: (h, params) => {
            let courseType = params.row.courseType
            let typeEnum = $constant.getEnum($constant.courseType, courseType)
            return h('span', typeEnum && typeEnum.text)
          }
        },
        {
          title: '课程名称',
          width: 180,
          key: 'lessonTitle'
        },
        {
          title: '开始、结束时间',
          align: 'center',
          width: 122,
          render: (h, params) => {
            let lsnBeginTime = params.row.lsnBeginTime
            let lsnEndTime = params.row.lsnEndTime
            return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm'))
          }
        },
        {
          title: '上课时长',
          align: 'center',
          width: 72,
          key: 'courseTime'
        },
        {
          title: '上课状态',
          width: 72,
          render: (h, params) => {
            let lsnSelStatus = params.row.lsnSelStatus
            let statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus)
            return h('span', statusEnum && statusEnum.text)
          }
        },
        {
          title: '是否代课',
          width: 70,
          key: 'isProxy',
          render: (h, params) => {
            let isProxy = params.row.isProxy
            return h('div', isProxy === 1 ? '是' : '否')
          }
        },
        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 72,
          render: (h, params) => {
            this.oldTch = params.row.oldOpenedId
            let courseType = params.row.courseType
            let isProxy = params.row.isProxy
            if (courseType === 8) {
              if (isProxy === 1) {
                return h('a', { on: { click: () => this.cancelProxyClass(params.row) } }, '取消代课')
              } else {
                return h('a', { on: { click: () => this.proxyClass(params.row) } }, '代课')
              }
            }
          }
        }
      ],
      bookLessonOpenedList: [],
      loadingSearch: false,
      loadingAdd: false,
      leaveParam: {
        lastWorkDay: '',
        startTime: '',
        resignReason: '',
        rehireFlag: null,
        resignType: null
      },
      leaveRule: {
        startTime: [
            { required: true, message: '请选择开始时间', trigger: 'blur' },
          { validator (rule, value, callback, source, options) {
              // let endTime = self.leaveParam.endTime
            let errors = []
              // let nowTime = new Date().getTime() / 1000
              // if (nowTime >= value) {
              //   errors.push('开始时间应在当前时间之后')
              // }
              // if (endTime !== '' && value >= endTime) {
              //   errors.push('开始时间应在结束时间之前')
              // }
            callback(errors)
          } }
        ],
        endTime: [
            { required: true, message: '请选择结束时间', trigger: 'blur' }
        ],
        remark: [
            { type: 'string', required: true, message: '请填写请假原因', trigger: 'blur' },
            { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }
        ],
      },
      startTime: '',
      endTime: '',
      remarkType: [
             { type: 'string', required: true, message: '请填写请假原因类别', trigger: 'blur' },
            { type: 'string', max: 100, message: '不知道就问主管', trigger: 'blur' }
      ]
    }
  },
  methods: {
    loadMonthRankScores () {
      const table = this.bookLessonOpenedList
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },

    add () {
      let self = this
      if (!self.leaveParam.resignType) {
        self.$Message.error('请选择离职类型')
        return
      }
      if (self.leaveParam.lastWorkDay === '') {
        self.$Message.error('请选择最后工作日期')
        return
      }
      self.loadingAdd = true
      let params = {
        lastWorkDay: self.leaveParam.lastWorkDay,
        tchId: self.tchId,
        resignReason: self.leaveParam.resignReason,
        rehireFlag: self.leaveParam.rehireFlag,
        resignType: self.leaveParam.resignType
      }
      self.$http.post('/tch/to-resigned', params).then(function (res) {
        self.loadingAdd = false
        if (res && res.status === 'ok') {
          self.$Message.success('离职成功!')
          self.visible = false
          self.title = ''
          if (self.successCallback) {
            self.successCallback()
          }
        }
      }).catch(function (e) {
        self.loadingAdd = false
      })
    },
    startTimeChange (value) {
      this.leaveParam.lastWorkDay = value
    },
    onBookLessonOpened () {
      let self = this
      let isNotError = true
      this.$refs.leaveForm.validateField('startTime', (valid) => {
        if (valid !== '') isNotError = false
      })
      this.$refs.leaveForm.validateField('endTime', (valid) => {
        if (valid !== '') isNotError = false
      })
      if (!isNotError) return
      self.loadingSearch = true
      let params = {}
      params.tchId = self.tchId
      params.startTime = self.leaveParam.startTime
      params.endTime = self.leaveParam.endTime
      self.$http.get('/bookLesson/tchLeave/list', { params: params }).then(function (res) {
        self.loadingSearch = false
        if (res.data.length <= 0) {
          self.$Message.info('没有涉及任何课节!')
          self.bookLessonOpenedList = []
          return
        }
        self.bookLessonOpenedList = res.data
          self.loadMonthRankScores()
        self.bookLessonOpenedList.map(item => {
          if (item.oldTch > 0) {
            item.isProxy = 1
          } else {
            item.isProxy = 0
          }
        })
      })
    },
    proxyClass (row) {
      row.show = true
      this.$emit('getProxyClassData', row)
    },
    cancelProxyClass (row) {
      this.$emit('getCancelProxyClassData', row)
    }
  },
  watch: {
    value (val) {
      this.visible = val
    },
    visible (val) {
      if (val === true) {
      }
      this.startTime = ''
      this.endTime = ''
      this.leaveParam.startTime = ''
      this.leaveParam.endTime = ''
      this.leaveParam.remark = ''
      this.leaveParam.remarkType = ''
      this.leaveParam.leaveType = 1
      this.leaveParam.resignType = null
      this.bookLessonOpenedList = []
      this.$emit('input', val)
    }
  }
}
</script>
<style lang="less" scoped>
.resign-content {
  padding: 8px 0;
}
.resign-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  margin-bottom: 20px;
  background: #fef8e6;
  border-left: 4px solid #E6A23C;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #8c6d00;
}
</style>



// WEBPACK FOOTER //
// ResignModal.vue?9f2da44c